import axios from "axios";

import { useActiveStore } from "../stores/active";

type TokenGetter = () => Promise<string | null>;

let getToken: TokenGetter = async () => null;

/** Called once from inside ClerkProvider so API calls carry the current session token. */
export const setTokenGetter = (getter: TokenGetter) => {
  getToken = getter;
};

export const api = axios.create({ baseURL: "/api" });

api.interceptors.request.use(async (config) => {
  const token = await getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const { workspaceId, brandId } = useActiveStore.getState();
  if (workspaceId) config.headers["X-Workspace-Id"] = workspaceId;
  if (brandId) config.headers["X-Brand-Id"] = brandId;
  return config;
});
